import { createSelector } from '@ngrx/store';

import { betslipSelector } from '../../base/store/selectors';

export const settingsSelector = createSelector(betslipSelector, (s) => s.settings);
export const settingsOddsAcceptanceSelector = createSelector(settingsSelector, (s) => s.oddsAcceptance);
export const settingsNotificationsSelector = createSelector(settingsSelector, (s) => s.notifications);
